import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import "./GetInfo.sass";

export const GetInfo = ({ id }) => {
  const [content, setContent] = useState("");

  useEffect(() => {
    if (id === 0) return;

    const fetchData = async () => {
      const res = await fetch(
        `${process.env.REACT_APP_URL}/general-by-id/${id}`
      );
      const data = await res.json();

      setContent(data);
    };

    fetchData().catch(console.error);
  }, [id]);

  return (
    <div className="row no-gutters general-container">
      <Helmet>
        <title>{content.seo_title_es}</title>
        <meta name="description" content={content.seo_content_es} />
      </Helmet>
      <div dangerouslySetInnerHTML={{ __html: content.content_es }} />
    </div>
  );
};

GetInfo.propTypes = {
  id: PropTypes.number.isRequired,
};
